import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeader } from '../ui/SectionHeader';
import { XIcon, CheckIcon } from 'lucide-react';
export function Transformacion() {
  const antes = ['Te despertás en la madrugada con ardor en el pecho', 'Cada comida es una apuesta: ¿esto me hará daño?', 'Dependencia diaria del omeprazol o antiácidos', 'Evitás salidas sociales por miedo al reflujo', 'Frustración de no saber qué funciona realmente'];
  const despues = ['Noches sin interrupciones. Descanso profundo y reparador', 'Sabés qué comés con confianza y qué evitar con claridad', 'Menos episodios de acidez, menos dependencia de pastillas', 'Podés cenar afuera, disfrutar sin ansiedad digestiva', 'Control real: sabés exactamente qué hacer cuando aparece el ardor'];
  return <section id="antes-despues" className="bg-blanco py-[100px]" data-id="element-271">
      <div className="container-custom" data-id="element-272">
        <SectionHeader eyebrow="La transformación" title={<>
              Dos realidades.
              <br data-id="element-274" />
              Una misma persona.
            </>} theme="light" data-id="element-273" />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-0 rounded-[12px] overflow-hidden mt-[60px] shadow-[0_20px_60px_rgba(0,0,0,0.08)]" data-id="element-275">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-[#1a0a0a] p-10" data-id="element-276">
            <div className="text-[14px] md:text-[12px] font-bold tracking-[3px] uppercase text-red-400/80 mb-6" data-id="element-277">
              Sin el protocolo
            </div>
            <div className="flex flex-col gap-4.5" data-id="element-278">
              {antes.map((item, idx) => <div key={idx} className="flex items-start gap-3 mb-4 last:mb-0" data-id="element-279">
                  <XIcon className="w-5 h-5 shrink-0 mt-0.5 text-red-500" data-id="element-280" />
                  <p className="text-[16px] text-white/65 leading-[1.6]" data-id="element-281">
                    {item}
                  </p>
                </div>)}
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-verde-oscuro p-10" data-id="element-282">
            <div className="text-[14px] md:text-[12px] font-bold tracking-[3px] uppercase text-dorado mb-6" data-id="element-283">
              Con el protocolo
            </div>
            <div className="flex flex-col gap-4.5" data-id="element-284">
              {despues.map((item, idx) => <div key={idx} className="flex items-start gap-3 mb-4 last:mb-0" data-id="element-285">
                  <CheckIcon className="w-5 h-5 shrink-0 mt-0.5 text-verde-claro" data-id="element-286" />
                  <p className="text-[16px] text-white/85 leading-[1.6]" data-id="element-287">
                    {item}
                  </p>
                </div>)}
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}